export interface UserSettings { timezone: string }
export type BillingPlan = 'free' | 'pro';
export interface BillingStatus { plan: BillingPlan; current_period_end: string | null }
export interface AdminCostSnapshot {
  days: number; buckets: { known: number; estimated: number; unknown: number };
  bucket_counts: { known: number; estimated: number; unknown: number };
  outbound_count: number; unknown_outcomes: number; excluded_founder_test: number;
}
export interface AdminOperationalUser {
  id: string; timezone: string; consent: { sms_opt_in: boolean; opted_in_at: string | null };
  pause: { until: string | null; checkins_until: string | null };
  schedules: Array<{ id: string; kind: string; mode: string; status: string; timezone: string; next_occurrence: string | null; occurrences: Array<{ id: string; state: string; due_at: string | null; expires_at: string | null; reason: string | null }> }>;
  subscription: { status: string; plan: string; effective_plan: string; period_end?: string | null; cancel_at_period_end?: boolean };
  allowance: { tier: string; limit: number; reserved: number; consumed: number; remaining: number; resets_at: string } | null;
  exclusion: string | null;
}
export interface AdminOperational {
  generated_at: string; status: string; readiness: { ready: boolean; reason: string | null };
  users: AdminOperationalUser[]; queue: Record<string, number | string>; outbound: Record<string, number>;
  workers: Array<{ worker: string; ready: boolean; heartbeat_at: string | null; reason: string | null }>;
  costs: AdminCostSnapshot;
}

export interface RecurrenceConfig {
  pattern: 'none' | 'daily' | 'weekdays' | 'weekly' | 'monthly';
  mode: 'fixed' | 'completion';
  last_completed: string | null;
  next_reset: string | null;
  skip_next: boolean;
}
export interface TodoItemType {
  id: number; list_id: number; parent_id: number | null; content: string;
  completed: boolean; position: number; due_date: string | null; flag: boolean;
  recurrence: RecurrenceConfig; created_at: string; updated_at: string;
  completed_at?: string | null; deleted_at?: string | null; version: number;
  children?: TodoItemType[];
}
export interface TodoListType {
  id: number; name: string; position: number; created_at: string; updated_at: string;
  deleted_at?: string | null; version: number; todos?: TodoItemType[];
}
export interface TodoCreateData { content: string; position?: number; parent_id?: number | null; due_date?: string | null; flag?: boolean; recurrence?: Partial<RecurrenceConfig> }
export interface TodoUpdateData { content?: string; position?: number; list_id?: number; parent_id?: number | null; due_date?: string | null; flag?: boolean; recurrence?: Partial<RecurrenceConfig>; version: number }
export interface ListCreateData { name: string; position?: number }
export interface ListUpdateData { name?: string; position?: number; version?: number }
export interface ReorderData { items: Array<{ id: number; version: number; position: number; list_id?: number; parent_id?: number | null }> }
export class VersionMismatchError extends Error { constructor(public details: any) { super('This item changed elsewhere. Refresh to resolve the conflict.'); this.name = 'VersionMismatchError'; } }
